// Librerías
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';

// Componentes
import CampanaHeader from '../components/CampanaVisibilidad/CampanaHeader';
import CampanaHero from '../components/CampanaVisibilidad/CampanaHero';
import CampanaWhatIs from '../components/CampanaVisibilidad/CampanaWhatIs';
import CampanaHowItWorks from '../components/CampanaVisibilidad/CampanaHowItWorks';
import CampanaPricing from '../components/CampanaVisibilidad/CampanaPricing';
import CampanaFomo from '../components/CampanaVisibilidad/CampanaFomo';
import CampanaCta from '../components/CampanaVisibilidad/CampanaCta';
import Footer from '../components/Footer/Footer';

// Estilos
import '../assets/styles/CampanaVisibilidad/campana.css';

ReactGA.initialize('G-RFYCNS3LB1');

const CampanaVisibilidad = () => {
  useEffect(() => {
    // Track page view
    ReactGA.send({ hitType: 'pageview', page: '/campana-visibilidad' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Campaña Visibilidad | Alohar</title>
        <meta
          name="description"
          content="Destacá tu alojamiento en Carnaval y Semana Santa. Planes de visibilidad por campaña con cupos limitados."
        />
        <meta
          name="keywords"
          content="alohar, alojamiento, carnaval, semana santa, visibilidad, argentina, pesos"
        />
        <meta property="og:title" content="Campaña Visibilidad | Alohar" />
        <meta
          property="og:description"
          content="Destacá tu alojamiento en Carnaval y Semana Santa. Planes de visibilidad por campaña con cupos limitados."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <main className="campana-visibilidad">
        <CampanaHeader />
        <CampanaHero />
        <CampanaWhatIs />
        <CampanaHowItWorks />
        <CampanaPricing />
        <CampanaFomo />
        <CampanaCta />
        <Footer />
      </main>
    </>
  );
};

export default CampanaVisibilidad;
